/** @jsx jsx */

import { ReactNode } from 'react';

import { createKeyHandler } from '@zapier/common-utils';
import {
  ColorValue,
  Colors,
  Icon,
  IconName,
  Margin,
  Spacer,
  Text,
} from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import GuideIcon from './GuideIcon';

const Styles = {
  root: ({ isCondensed }) => css`
    display: flex;
    align-items: center;
    padding: 15px;
    justify-content: space-between;
    border-bottom: ${isCondensed ? `1px solid ${Colors.GrayWarm4}` : 'none'};
    &:hover {
      background-color: ${isCondensed ? Colors.GrayWarm2 : 'inherit'};
      cursor: ${isCondensed ? 'pointer' : 'inherit'};
    }
  `,
  titleWrapper: css`
    align-items: center;
    display: flex;
    margin-bottom: 15px;
  `,
};

type Props = {
  content: ReactNode;
  icon: IconName;
  iconBackgroundColor: ColorValue;
  isCondensed?: Boolean;
  onClick?: () => void;
  title: string;
};

const GuideSection = ({
  content,
  icon,
  iconBackgroundColor,
  isCondensed,
  onClick,
  title,
}: Props) => {
  return (
    <div
      css={Styles.root({ isCondensed })}
      {...(onClick && {
        onClick,
        onKeyDown: createKeyHandler(['enter'], onClick),
      })}
      {...(isCondensed && { role: 'button', tabIndex: 0 })}
    >
      <div>
        <div css={Styles.titleWrapper}>
          <GuideIcon
            backgroundColor={iconBackgroundColor}
            name={icon}
            size={isCondensed ? 30 : 40}
          />
          <Spacer width={15} />
          <Text fontWeight={600} tag="span" type="Body4">
            {title}
          </Text>
        </div>
        <Text>{content}</Text>
      </div>
      {isCondensed && (
        <Margin margin="0px 20px 0px 20px">
          <Icon name="arrowSmallRight" size={30} />
        </Margin>
      )}
    </div>
  );
};

GuideSection.defaultProps = {
  isCondensed: false,
  onClick: null,
};

export default GuideSection;
